import { Component, OnInit } from '@angular/core';
import { PaymentSettingsService } from 'app/@core/backend/common/services/CalorieFriend/payment-settings.service';
import { NbToastrService } from '@nebular/theme';
import { Observable } from 'rxjs';
import { StripeAccount } from 'app/@core/interfaces/common/stripe';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-payment-settings',
  templateUrl: './payment-settings.component.html',
  styleUrls: ['./payment-settings.component.scss'],
})
export class PaymentSettingsComponent implements OnInit {
  constructor(
    private paymentSettingsService: PaymentSettingsService,
    private toastrService: NbToastrService
  ) {}

  connecting = false;
  currentAccount: Observable<StripeAccount>;

  ngOnInit() {
    this.currentAccount = this.paymentSettingsService.currentAccount;
    this.paymentSettingsService.isLoading.subscribe((status: boolean) => {
      this.connecting = status;
    });
  }

  connectToStripe() {
    this.connecting = true;
    this.paymentSettingsService.connectToStripe().subscribe({
      next: () => {
        this.connecting = false;
      },
      error: (e: any) => {
        this.connecting = false;
        this.toastrService.danger(e.message, 'An error occurred');
      },
    });
  }

  reset() {
    this.connecting = true;
    this.paymentSettingsService.reset().subscribe((status: boolean) => {
      this.connecting = false;
    });
  }

  expressLogin() {
    this.connecting = true;
    this.paymentSettingsService.expressLogin().pipe(finalize(()=>this.connecting = false)).subscribe((res) => {
      window.open(res.url, "_blank");
    });
  }
}
